import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';

@Component({
  selector: 'cigna-cfb-contractor-exit-dialog',
  templateUrl: './contractor-exit-dialog.component.html',
  styleUrls: ['./contractor-exit-dialog.component.scss'],
})
export class ContractorExitDialogComponent implements OnInit {
  templateId: string;
  constructor(
    public dialogRef: MatDialogRef<ContractorExitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private appstateFacade: AppstateFacade,
  ) {
    this.templateId = this.data;
  }

  ngOnInit() {}

  onExitYesClicked() {
    this.appstateFacade.stashOnboardingInfo(true);
    this.dialogRef.close('exit');
  }

  onExitNoClicked() {
    this.dialogRef.close();
  }

  onRestartClicked() {
    this.dialogRef.close('restart');
  }

  onExitClicked() {
    this.dialogRef.close('exit');
  }
}
